import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_HALAL_STOCK_BULK_UPLOAD } from "../../../config/api";

export const bulkUploadStocks = createAsyncThunk(
  "stocks/bulkUpload",
  async ({ data, callback, failed }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_HALAL_STOCK_BULK_UPLOAD,
        data: data,
        contentType: "multipart/form-data",
        serializerConfig: { indexes: null },
      });

      toast.success("Stocks uploaded successfully");
      callback && callback(response?.data);

      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed && failed();
      return rejectWithValue(error.message);
    }
  }
);
